import { DermloopConsentTypeEnum } from '@dermloop/static-values';
import { Exclude } from 'class-transformer';
import {
  IsBoolean,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
  Min,
} from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../base.dto';
import { ConsentRevisionDto } from './consent-revision.dtos';

export interface ConsentDto extends BaseDto {
  jurisdictionalGroupIds: string[];
  internalName: string;
  internalDescription: string;
  externalConsent: boolean;
  mandatory: boolean;
  consentType: DermloopConsentTypeEnum;
  url: string | undefined;
  revision: ConsentRevisionDto | undefined;
}

export class CreateConsentDto
  extends BaseCreateDto
  implements Partial<ConsentDto>
{
  @IsNotEmpty()
  @IsString()
  internalDescription: string;

  @IsNotEmpty()
  @IsString()
  internalName: string;

  @IsOptional()
  @IsBoolean()
  externalConsent?: boolean;

  @IsOptional()
  @IsBoolean()
  mandatory?: boolean;

  @IsOptional()
  @IsUUID('all', { each: true })
  jurisdictionalGroupIds?: string[];

  @IsEnum(DermloopConsentTypeEnum)
  consentType: DermloopConsentTypeEnum;

  @Exclude()
  url?: never;

  @Exclude()
  revision?: never;
}

export class UpdateConsentDto
  extends BaseUpdateDto
  implements Partial<ConsentDto>
{
  @Exclude()
  internalDescription?: never;

  @Exclude()
  internalName?: never;

  @IsOptional()
  @IsBoolean()
  externalConsent?: boolean;

  @IsOptional()
  @IsBoolean()
  mandatory?: boolean;

  @IsOptional()
  @IsUUID('all', { each: true })
  jurisdictionalGroupIds?: string[];

  @Exclude()
  url?: never;

  @Exclude()
  revision?: never;
}

export class ConsentSearchQueryDto {
  @IsOptional()
  @IsNumber()
  @Min(0)
  skip?: number;

  @IsOptional()
  @IsNumber()
  @Min(1)
  @Max(30)
  take?: number;

  @IsOptional()
  @IsEnum(DermloopConsentTypeEnum, { each: true })
  consentTypes?: DermloopConsentTypeEnum[];
}
